import React from 'react';
import { useLocation, Link } from 'react-router-dom';
// Icons & Data
import { CompanyName, LocationCity } from '../../utils/Constants';
import SocialMediaCTA from './SocialMediaCTA';
import { FooterLinksArray } from '../../utils/data/FooterData';

function SocialMediaCtaComponent() {
  const location = useLocation();

  return (
    <section className='grid w-full bg-colour2 gap-4 pt-10 pb-12 z-30 pointer-events-auto'>
      <article className='grid justify-center text-center px-6'>
        {location.pathname === '/' && (
          <>
            <div>
              <p className='text-3xl md:text-5xl md:mb-6 font-kugile'>
                Follow Me on Social Media
              </p>
            </div>
            <div className='grid justify-center py-6'>
              <SocialMediaCTA />
            </div>
          </>
        )}
        <div className='font-semibold text-xl lg:text-3xl font-hello-paris-medium'>
          {CompanyName}
        </div>
        <div className='text-sm text-gray-400'>Perth Australia </div>
        <div className='text-sm text-gray-500 mt-4'>
          © {new Date().getFullYear()} {CompanyName}. All rights reserved.
          <br />
          Unauthorized use or reproduction of content is strictly prohibited.
        </div>
      </article>
      <div className='grid w-full'>
        <ul className='grid grid-cols-3 justify-center text-center md:grid-flow-col gap-x-6 w-fit mx-auto'>
          {FooterLinksArray.map((link, index) => (
            <li key={index}>
              <Link
                to={link.route}
                aria-label={`${link.name} page navigation tab`}
                className='text-sm lg:text-2xl font-kugile'
                onClick={() => window.scroll(0, 0)}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default SocialMediaCtaComponent;
